import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Box, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const C = {
  purple: '#552583', purpleDark: '#33154f', gold: '#FDB927',
  bg: '#E4F0F6', text: '#1a1a1a', textSoft: '#4a4a4a',
};

export default function NotFound() {
  return (
    <Box sx={{ background: C.bg, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{
          width: 100, height: 100, borderRadius: '28px', mx: 'auto', mb: 4,
          background: `linear-gradient(135deg, ${C.purple}, ${C.gold})`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: `0 12px 40px rgba(85,37,131,0.25)`,
        }}>
          <SearchOffIcon sx={{ fontSize: 50, color: 'white' }} />
        </Box>

        <Typography variant="h1" fontWeight={900} sx={{
          fontSize: { xs: '5rem', md: '7rem' }, lineHeight: 1,
          background: `linear-gradient(135deg, ${C.purple}, ${C.gold})`,
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          mb: 2,
        }}>
          404
        </Typography>

        <Typography variant="h5" fontWeight={700} sx={{ color: C.text, mb: 1.5 }}>
          Page introuvable
        </Typography>

        <Typography variant="body1" sx={{ color: C.textSoft, mb: 4, maxWidth: 380, mx: 'auto', lineHeight: 1.7 }}>
          La page que vous recherchez n'existe pas ou a été déplacée. Vérifiez l'URL ou retournez à l'accueil.
        </Typography>

        <Button component={Link} to="/" variant="contained" size="large" startIcon={<HomeIcon />}
          sx={{
            py: 1.5, px: 4, borderRadius: '14px', textTransform: 'none', fontWeight: 700, fontSize: '1rem',
            background: `linear-gradient(135deg, ${C.purple}, ${C.gold})`,
            boxShadow: `0 6px 20px rgba(85,37,131,0.3)`,
            '&:hover': { boxShadow: `0 8px 28px rgba(85,37,131,0.45)` },
          }}>
          Retour à l'accueil
        </Button>
      </Container>
    </Box>
  );
}
